'use client';

import { Maximize, Minimize } from 'lucide-react';

import React from 'react';

import { Tooltip } from '@/shared/components';

import { cn } from '@/lib/utils';

import { useHLSPlayer } from '../contexts/hls-player-provider';
import type { IControlsProps } from '../types';

function FullscreenButton({ className }: IControlsProps) {
	const { uiState, toggleFullscreen } = useHLSPlayer();
	const { isFullscreen } = uiState;

	return (
		<Tooltip text="Fullscreen">
			<button
				onClick={toggleFullscreen}
				className={cn(
					'flex size-7 items-center justify-center rounded-md text-white transition-colors hover:bg-white/20',
					className
				)}
				aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
			>
				{isFullscreen ? <Minimize size={16} /> : <Maximize size={16} />}
			</button>
		</Tooltip>
	);
}

export default React.memo(FullscreenButton);
